import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useMediaQuery } from "react-responsive";
import type { TableProps } from "antd";

import styles from "./DataTable.module.css";

function DataTable({
    pagination,
    canceledRow,
    hasScroll,
    loading,
    columns,
    dataSource,
    rowKey,
    onRowKey,
    onSelected,
    onRow,
    defaultSelectedRowKeys,
    onChange,
    tableSize,
    pageNumber,
    total,
}: {
    pagination?: boolean;
    canceledRow?: Array<number>;
    hasScroll?: boolean;
    loading?: boolean;
    columns: any;
    dataSource: any;
    rowKey?: any;
    onRowKey?: (record: any) => string;
    onSelected?: (values: any, selectedRowKeys: React.Key[]) => void;
    onRow?: (values: any) => void;
    defaultSelectedRowKeys?: Array<string>;
    onChange?: TableProps<any>["onChange"];
    tableSize?: number;
    pageNumber?: number;
    total?: number;
}) {
    const isMobile = useMediaQuery({ maxWidth: 600 });
    const [check, setCheck] = useState<Array<string> | React.Key[]>();
    const [selectedRow, setSelectedRow] = useState<number>();

    useEffect(() => {
        setCheck(defaultSelectedRowKeys);
    }, [defaultSelectedRowKeys]);

    return (
        <Table
            className={onRow !== undefined ? `${styles.table} ${styles.pointerTable}` : `${styles.table}`}
            rowClassName={(record, index) =>
                index === selectedRow ? styles.selectedRow : canceledRow?.includes(record.rentId || record.couponId || record.orderId) ? styles.canceledRow : ""
            }
            loading={loading}
            showSorterTooltip={false}
            pagination={
                pagination !== false && {
                    current: pageNumber,
                    pageSize: tableSize,
                    total,
                    position: ["bottomCenter"],
                    simple: isMobile ? true : false,
                    showTotal: (total) => `총 ${total}개`,
                }
            }
            rowSelection={
                onSelected === undefined
                    ? undefined
                    : {
                          type: "checkbox",
                          onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                              onSelected !== undefined && onSelected(selectedRows, selectedRowKeys);
                              setCheck(selectedRowKeys);
                          },
                          selectedRowKeys: check,
                      }
            }
            rowKey={rowKey ? rowKey : onRowKey ? (record) => onRowKey(record) : undefined}
            columns={columns}
            dataSource={dataSource}
            scroll={hasScroll ? { y: 1500 } : undefined}
            onRow={(record, index) => {
                return {
                    onClick: () => {
                        setSelectedRow(index);
                        onRow !== undefined && onRow(record);
                    },
                };
            }}
            onChange={onChange}
        />
    );
}

export default DataTable;
